import React, { useCallback, useEffect, useRef, useState } from "react";
import "./SearchBar.scss";
// import Gridicon from '../../common/assets/svg/GridupdatedIcon.svg';
// import listicon from '../../common/assets/svg/listupdatedIcon.svg'

import { ReactComponent as Gridicon } from "../../common/assets/svg/GridupdatedIcon.svg";
import { ReactComponent as Listicon } from "../../common/assets/svg/listupdatedIcon.svg";
import { off } from "process";

interface SearchBarProps {
  items: any[];
  setSearchedItem?: any;
  // searchQuery:any
  onSearch: (query: string) => void;
  searchIcon?: string;
  onFilterClick: () => void;
  onItemClick: (item: any) => void;
  setIsSearchActive: (isSearchActive: boolean) => void;
  setSearchResults: (searchResults: boolean) => void;
  isSearchActive: boolean;
  setDishes?: any;
  setShowGrid?: any;
  showGrid?: any;
}

const SearchBar: React.FC<SearchBarProps> = ({
  items,
  onSearch,
  searchIcon,
  onFilterClick,
  onItemClick,
  setIsSearchActive,
  setSearchResults,
  isSearchActive,
  // searchQuery,
  setSearchedItem,
  setDishes,
  setShowGrid,
  showGrid,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [matchedItems, setMatchedItems] = useState<any[]>([]);
  const inputRef = useRef<HTMLInputElement>(null);


  const handleSearchChange = (query: string) => {
      if (query.length === 1 && query === ' ') return;
    if (query === "") {
      setIsSearchActive(false);
    } else {
      setIsSearchActive(true);
    }

    setSearchQuery(query);

    // Filter items based on search query
    if (query.trim()) {
      const filtered = items.filter((item) =>
        item?.display &&item?.itemName?.toLowerCase().includes(query.toLowerCase())
      );
      setMatchedItems(filtered);
      if (filtered.length === 0 && query.trim() !== "") {
        setSearchResults(true);
      } else setSearchResults(false);
    } else {
      setMatchedItems([]);
      setSearchResults(false);
    }
  };

  const handleSearchFocus = () => {};
  
  const handleSearchBlur = () => {
    // Delay hiding results to allow for item click
    setTimeout(() => {
      if (!searchQuery) {
        setIsSearchActive(false);
      }
    }, 200);
  };

  const handleClearSearch = () => {
    setSearchQuery("");
    setMatchedItems([]);
    setSearchResults(false);
    setIsSearchActive(false);
    setSearchedItem("");
    onSearch("");
  };

  const handleItemSelect = (item: any) => {
    setSearchQuery(item?.itemName);
    setSearchedItem(item?.itemName);
    setMatchedItems([]);
    setSearchResults(false);
    onItemClick(item);
    setDishes([item]);
    // onSearch(item.itemName);
  };
  const getMenuItemImageUrl = useCallback(
    (imgId: string | null, ext: string | null) => {
      return process.env.REACT_APP_IMAGE_URL + "img" + "/" + imgId + "." + ext;
    },
    []
  );

  // useEffect(() => {
  //   if (window.innerWidth < 768 && inputRef.current) {
  //     inputRef.current.focus();
  //   }
  // }, []);

  const handleGridview = () => {
    setShowGrid(true);
    localStorage.setItem("View", "Grid");
  };

  const handlelistview = () => {
    setShowGrid(false);
    localStorage.setItem("View", "List");
  };

  return (
    <div className="search-wrapper">
      <div className={`search-bar-container ${isSearchActive ? "active" : ""}`}>
        <div className="searchIcon-input-container">
          <div
            className="search-icon-input-container-new-mobile"
            style={{ width: "95vw"}}
          >
            <img
              src={searchIcon}
              alt="search"
              className="search-icon-new-mobile"
            />
            <input
              type="text"
              ref={inputRef}
              className="input-box-new-mobile"
              placeholder="Search dishes..."
              value={searchQuery}
              onClick={(e) => e.currentTarget.focus()}
              onChange={(e) => handleSearchChange(e.target.value)}
              onFocus={handleSearchFocus}
              onBlur={handleSearchBlur}
              autoFocus={false}
            />
          </div>
          <div className="clear-button-container">
            {isSearchActive && searchQuery && (
              <button className="clear-button" onClick={handleClearSearch}>
                ×
              </button>
            )}
          </div>
        </div>

        {/*} <div className="view-type">
          <button onClick={handlelistview} className={`grid-and-list-view ${!showGrid ? 'active' : ''}`}>
            <Listicon className="ViewIconList" />
          </button>
          <button onClick={handleGridview} className={`grid-and-list-view ${showGrid ? 'active' : ''}`}>

            <Gridicon className="ViewIconGrid" />
          </button>
        </div>*/}

        {/* {!isSearchActive && (
          <div className="filter-icon-container">
            <img src={filterIcon} alt="filter" onClick={onFilterClick} />
          </div>

        )} */}
      </div>

      {matchedItems.length > 0 && isSearchActive && (
        <div className="search-results">
          {matchedItems.map((item) => (
            <div
              key={item.id}
              className="search-result-item"
              onClick={() => {
                handleItemSelect(item);
              }}
            >
              {item?.itemImage && item?.itemType && (
                <img
                  src={
                    getMenuItemImageUrl(
                      item?.itemImage ?? null,
                      item?.itemType?.split("/")[1] ?? null
                    ) || ""
                  }
                  alt=""
                  className="itemImage-mobile-search"
                />
              )}

              <span className="item-name">{item.itemName}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchBar;
